<google-map 
    width="100vw"
    height="100vh"
    id="MAP_Markers"
    [center]="center"
    [zoom]="zoom"
    [options]="options"
    (mapDragend)="dragAction()"

>

<input type="hidden" name="lat" id="lat" value="">
<input type="hidden" name="lng" id="lng" value="">




@if (type == "ALL" || type == "BOAT") {
    @for (boatMarker of boatMarkers; track $index) {
        @if (getDistanceFromLatLonInKm(boatMarker.position.lat,boatMarker.position.lng)) {
          
            <map-advanced-marker  (mapClick)="showDetail('BOAT',boatMarker.name,boatMarker.stationId,boatMarker.branch,boatMarker.title,boatMarker.address,boatMarker.floor,boatMarker.capacity,boatMarker.village,boatMarker.lat,boatMarker.lng)" [position]="boatMarker.position" [options]="createMarkerOptions('boat',boatMarker.name)"/>
          
            
        }
        
        
    }
}




<map-advanced-marker [position]="center"  [options]="createMarkerOptions('point','')" />
    <map-circle [center]="mapCenter" [radius]="radius" [options]="circleOptions" />
</google-map>